var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgFontsIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.333 12.607H14.667c-1.197 0-2.167.97-2.167 2.167V36.44c0 1.197.97 2.167 2.167 2.167h21.666c1.197 0 2.167-.97 2.167-2.167V14.774c0-1.197-.97-2.167-2.167-2.167Z",
    stroke: "#7B7B7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.574 33.333c.215 0 .425-.019.63-.056.215-.047.41-.098.588-.154v1.316c-.187.084-.43.154-.728.21a4.38 4.38 0 0 1-.938.098c-.43 0-.821-.07-1.176-.21a1.733 1.733 0 0 1-.84-.756c-.205-.355-.308-.85-.308-1.484V28.35H21.78v-.77l1.12-.616.56-1.61h1.106v1.666h2.156v1.33h-2.156v3.934c0 .355.093.62.28.798.187.168.43.252.728.252Zm6.5 1.274h-1.792v-8.484h-2.87v-1.512h7.532v1.512h-2.87v8.484Z",
    fill: "#7B7B7B"
  })));
};
export { SvgFontsIcon as ReactComponent };
export default __webpack_public_path__ + "d7e2c1ee733d6d6321162309b421179d.svg";